<div class="container-fluid">
  <!-- PRAZO ENCERRADO (sem confirmação) -->
  @if (prazoEncerrado) {
    <div class="card mt-3">
      <div class="card-body text-center py-5">
        <div class="mb-3">
          <i
            class="fas fa-calendar-times text-secondary"
            style="font-size: 4rem"
          ></i>
        </div>
        <h4 class="fw-bold">Prazo para confirmação de vagas neste ciclo encerrado.</h4>
        <p class="text-muted mb-1">
          O prazo para confirmação de vagas deste ciclo já se encerrou.
        </p>
        <p class="text-muted">
          Não é possível realizar a adesão. Em caso de dúvidas, procure a
          coordenação do programa.
        </p>
        <button
          class="br-button secondary mt-3"
          type="button"
          (click)="cancelar()"
        >
          Voltar
        </button>
      </div>
    </div>
  }

  @if (!prazoEncerrado) {
    <app-steps
      [steps]="steps"
      [stepChange]="stepChangeEmitter"
      (stepClick)="onClickStep($event)"
    ></app-steps>
  }

  @if (cicloSelected) {
    <div class="d-flex justify-content-end mt-2">
      <button
        class="br-button secondary"
        type="button"
        title="Histórico da confirmação de vagas"
        (click)="abrirHistorico()"
      >
        <i class="fa fa-history me-1"></i> Histórico
      </button>
    </div>
  }

  <!-- STEP 1: Dados da Adesão -->
  @if (!prazoEncerrado && currentStep === 1) {
    <div class="alert alert-info mt-3" role="alert">
      <i class="fas fa-info-circle me-1"></i>
      <strong>Como preencher:</strong> Clique em Ver lista de instalações para
      expandir → marque o checkbox confirmando que leu os requisitos → clique no
      botão "Adicionar CNES" para adicionar os estabelecimentos (CNES) e a
      quantidade de vagas.
    </div>

    @for (
      grupo of vagasAprimoramento;
      track grupo.tipoAprimoramento.id;
      let i = $index
    ) {
      <app-card-collapse
        [titulo]="grupo.tipoAprimoramento.nome"
        [badge]="i + 1 | number: '2.0-0'"
        class="mb-3 d-block"
      >
        <div class="d-flex align-items-start mb-3 flex-wrap gap-2">
          <div class="d-flex align-items-center">
            <div class="br-checkbox">
              <input
                type="checkbox"
                [id]="'aceite-' + grupo.tipoAprimoramento.id"
                [checked]="aceites.get(grupo.tipoAprimoramento.id)"
                [disabled]="
                  !instalacaoVista.has(grupo.tipoAprimoramento.id) ||
                  acoesBloqueadas()
                "
                (change)="onAceiteChange(grupo.tipoAprimoramento.id, $event)"
                class="me-2"
              />
              <label
                [for]="'aceite-' + grupo.tipoAprimoramento.id"
                class="mb-0"
              >
                Confirmo que li a lista e possuo as instalações mínimas
                necessárias para a execução do serviço em todos os
                estabelecimentos.
              </label>
            </div>
          </div>
          <a
            href="#"
            class="ms-md-2"
            (click)="openInstalacaoModal(grupo, $event)"
            >Ver lista de instalações</a
          >
        </div>

        <table class="br-table table stack-mobile">
          <thead class="table-light">
            <tr>
              <th>CNES</th>
              <th>Estabelecimento</th>
              <th>Qtd. Vagas</th>
              <th style="width: 80px">Ação</th>
            </tr>
          </thead>
          <tbody>
            @for (
              item of getEstabelecimentos(grupo.tipoAprimoramento.id);
              track item.cnes
            ) {
              <tr>
                <td data-label="CNES">{{ item.cnes }}</td>
                <td data-label="Estabelecimento">
                  {{ item.nomeEstabelecimento || "-" }}
                </td>
                <td data-label="Qtd. Vagas">{{ item.qtdVagas }}</td>
                <td data-label="Ação" class="text-center">
                  <button
                    class="br-button secondary small"
                    type="button"
                    title="Remover"
                    [disabled]="acoesBloqueadas()"
                    (click)="removeCnes(grupo.tipoAprimoramento.id, item.cnes)"
                  >
                    <i class="fas fa-trash-alt"></i>
                  </button>
                </td>
              </tr>
            }
            @if (getEstabelecimentos(grupo.tipoAprimoramento.id).length === 0) {
              <tr>
                <td colspan="4" class="text-center text-muted fst-italic">
                  Nenhum estabelecimento adicionado.
                </td>
              </tr>
            }
          </tbody>
          <tfoot>
            <tr class="table-light">
              <td colspan="4">
                <strong>Total estabelecimentos:</strong>
                {{ getEstabelecimentos(grupo.tipoAprimoramento.id).length }}
                &nbsp;|&nbsp;
                <strong>Total vagas distribuídas:</strong>
                {{ getTotalVagas(grupo.tipoAprimoramento.id) }}
              </td>
            </tr>
          </tfoot>
        </table>

        <button
          class="br-button secondary small"
          type="button"
          [disabled]="
            !aceites.get(grupo.tipoAprimoramento.id) || acoesBloqueadas()
          "
          (click)="openCnesModal(grupo)"
        >
          <i class="fas fa-edit me-1"></i> Adicionar CNES
        </button>
      </app-card-collapse>
    }

    @if (vagasCarregadas && vagasAprimoramento.length === 0) {
      <div class="alert alert-warning mt-3">
        <i class="fas fa-exclamation-triangle me-1"></i>
        Nenhuma vaga disponível para este ciclo.
      </div>
    }

    @if (chamadaCarregada && acoesBloqueadas()) {
      <div class="alert alert-warning mt-3" role="alert">
        <i class="fas fa-lock me-1"></i>
        O período de confirmação está encerrado. Não é possível alterar a
        adesão.
      </div>
    }

    <div class="d-flex justify-content-end mt-4 gap-2">
      <button class="br-button secondary" type="button" (click)="cancelar()">
        Cancelar
      </button>
      <button
        class="br-button primary"
        type="button"
        [disabled]="acoesBloqueadas()"
        (click)="goToStep2()"
      >
        Próximo
      </button>
    </div>
  }

  <!-- STEP 2: Resumo -->
  @if (currentStep === 2 && !confirmedSemVagas) {
    @if (acoesBloqueadas()) {
      <div class="alert alert-warning mt-3" role="alert">
        <i class="fas fa-lock me-1"></i>
        O período de confirmação está encerrado. Visualização somente leitura.
      </div>
    } @else {
      <div class="alert alert-info mt-3" role="alert">
        <i class="fas fa-info-circle me-1"></i>
        <strong
          >Confira as informações abaixo. Você ainda poderá editar até o fim do
          período de confirmação.</strong
        >
      </div>
    }

    <div class="mt-3">
      <h5>Resumo das Vagas</h5>
      <table class="br-table table mb-3 stack-mobile">
        <thead class="table-light">
          <tr>
            <th>Aprimoramento</th>
            <th>CNES</th>
            <th>Estabelecimento</th>
            <th>Nível</th>
            <th>Qtd. Vagas</th>
          </tr>
        </thead>
        <tbody>
          @for (grupo of vagasAprimoramento; track grupo.tipoAprimoramento.id) {
            @for (
              item of getEstabelecimentos(grupo.tipoAprimoramento.id);
              track item.cnes
            ) {
              <tr>
                <td data-label="Aprimoramento">
                  {{ grupo.tipoAprimoramento.nome }}
                </td>
                <td data-label="CNES">{{ item.cnes }}</td>
                <td data-label="Estabelecimento">
                  {{ item.nomeEstabelecimento || "-" }}
                </td>
                <td data-label="Nível">
                  <span class="badge" [ngClass]="badgeClass(item.nivelVaga)">{{
                    nivelLabel(item.nivelVaga)
                  }}</span>
                </td>
                <td data-label="Qtd. Vagas">{{ item.qtdVagas }}</td>
              </tr>
            }
          }
          @if (!hasEstabelecimentos()) {
            <tr>
              <td colspan="5" class="text-center text-muted fst-italic">
                Nenhum estabelecimento adicionado.
              </td>
            </tr>
          }
        </tbody>
      </table>
    </div>

    <div class="d-flex justify-content-end mt-4 gap-2">
      @if (acoesBloqueadas()) {
        <button
          class="br-button secondary"
          type="button"
          (click)="voltarParaConclusao()"
        >
          Voltar
        </button>
      } @else {
        <button class="br-button secondary" type="button" (click)="goToStep(1)">
          Voltar
        </button>
        <button class="br-button primary" type="button" (click)="goToStep3()">
          Próximo
        </button>
      }
    </div>
  }

  <!-- Resumo das vagas, anexado aos termos que exigem upload assinado -->
  <ng-template #resumoVagasTable>
    <table class="br-table table estabelecimentos-termo mt-2">
      <thead class="table-light">
        <tr>
          <th>CNES</th>
          <th>Nome Estabelecimento</th>
          <th>Aprimoramento</th>
          <th>Vagas</th>
          <th class="assinatura-gestor">Assinatura Gestor</th>
        </tr>
      </thead>
      <tbody>
        @for (grupo of vagasAprimoramento; track grupo.tipoAprimoramento.id) {
          @for (
            item of getEstabelecimentos(grupo.tipoAprimoramento.id);
            track item.cnes
          ) {
            <tr>
              <td>{{ item.cnes }}</td>
              <td>{{ item.nomeEstabelecimento || "-" }}</td>
              <td>{{ grupo.tipoAprimoramento.nome }}</td>
              <td>{{ item.qtdVagas }}</td>
              <td class="assinatura-gestor"></td>
            </tr>
          }
        }
        @if (!hasEstabelecimentos()) {
          <tr>
            <td colspan="5" class="text-center text-muted fst-italic">
              Nenhum estabelecimento adicionado.
            </td>
          </tr>
        }
      </tbody>
    </table>
  </ng-template>

  <!-- Conteúdo dos termos oculto para permitir download na tela de conclusão -->
  @if (confirmed) {
    @for (termo of termos; track termo.id) {
      <div [id]="'termo-conteudo-' + termo.id" style="display: none">
        <div [innerHTML]="termoConteudoSeguro(termo)"></div>
        @if (termo.stUploadAssinado) {
          <ng-container *ngTemplateOutlet="resumoVagasTable"></ng-container>
        }
      </div>
    }
  }

  <!-- CONCLUSÃO -->
  @if (confirmed) {
    @if (chamadaConfirmacao && isPeriodoAberto()) {
      <div
        class="alert alert-warning d-flex align-items-center mt-3 mb-0"
        role="alert"
      >
        <i class="fas fa-clock me-2"></i>
        <span>
          <strong>Período de confirmação aberto:</strong>
          {{ formatarData(chamadaConfirmacao.dtInicio) }} a
          {{ formatarData(chamadaConfirmacao.dtFim) }}
          — você poderá editar as informações até o encerramento deste período.
        </span>
      </div>
    }
    <div class="card mt-3">
      <div class="card-body text-center py-5">
        <div class="mb-3">
          <i
            class="fas fa-check-circle text-success"
            style="font-size: 4rem"
          ></i>
        </div>
        <h4 class="text-success fw-bold">Adesão confirmada com sucesso!</h4>
        <p class="text-muted mb-1">
          Sua confirmação de vagas para o PMM-E foi registrada.
        </p>
        <p class="text-muted">
          Você pode baixar os termos ou editar a adesão até o fim do período de
          confirmação.
        </p>
        <div class="d-flex flex-wrap justify-content-center gap-2 mt-4">
          @if (nuRefDocumentoConfirmacao) {
            <button
              class="br-button secondary"
              type="button"
              (click)="baixarDocumentoAnexado()"
            >
              <i class="fas fa-download me-1"></i> Baixar Termo Estabelecimentos
            </button>
          }
          @for (termo of termos; track termo.id; let i = $index) {
            @if (termo?.modeloTermoConfirmacao?.ciencia) {
              <button
                class="br-button secondary"
                type="button"
                (click)="baixarTermoPdf(termo)"
              >
                <i class="fas fa-download me-1"></i> Baixar Termo - Gestor
              </button>
            }
          }
          @if (isPeriodoAberto()) {
            <button
              class="br-button primary"
              type="button"
              (click)="editarAdesao()"
            >
              <i class="fas fa-pencil-alt me-1"></i> Editar Adesão
            </button>
          }
          <button
            class="br-button secondary"
            type="button"
            (click)="verResumo()"
          >
            Ver Resumo
          </button>
        </div>
      </div>
    </div>
  }

  <!-- CONCLUSÃO SEM VAGAS -->
  @if (confirmedSemVagas) {
    <div class="card mt-3">
      <div class="card-body text-center py-5">
        <div class="mb-3">
          <i
            class="fas fa-info-circle text-primary"
            style="font-size: 4rem"
          ></i>
        </div>
        <h4 class="fw-bold">
          Adesão não concluída por falta de indicação de vagas
        </h4>
        <p class="text-muted mb-1">
          Situação da adesão: <strong>Sem indicação de vagas</strong>
        </p>
        <p class="text-muted mb-1">Nenhuma vaga indicada neste ciclo.</p>
        <p class="text-muted mb-3">
          Não há termos de adesão a gerar neste cenário.
        </p>
        @if (isPeriodoAberto()) {
          <div class="alert alert-warning">
            Você poderá reverter esta decisão indicando vagas enquanto o período
            de confirmação estiver aberto.
          </div>
        }
        <div class="d-flex justify-content-between mt-4">
          @if (isPeriodoAberto()) {
            <button
              class="br-button secondary"
              type="button"
              (click)="editarAdesao()"
            >
              <i class="fas fa-pencil-alt me-1"></i> Voltar e indicar vagas
            </button>
          }
        </div>
      </div>
    </div>
  }

  <!-- STEP 3: Termos de Adesão -->
  @if (!confirmed && currentStep === 3) {
    <div class="mt-3">
      @if (acoesBloqueadas()) {
        <div class="alert alert-warning" role="alert">
          <i class="fas fa-lock me-1"></i>
          O período de confirmação está encerrado. Os termos estão disponíveis
          apenas para consulta e download.
        </div>
      }
      @for (termo of termos; track termo.id; let i = $index) {
        <div
          class="card mb-3"
          [class.opacity-50]="!isTermoInteractable(i)"
          [style.pointer-events]="!isTermoInteractable(i) ? 'none' : null"
        >
          <div class="card-body">
            @if (!isTermoInteractable(i)) {
              <p class="text-muted small mb-2">
                <i class="fas fa-lock me-1"></i> Complete o termo anterior para
                interagir.
              </p>
            }
            <div class="d-flex justify-content-between align-items-start gap-2">
              <h6>{{ termo.modeloTermoConfirmacao?.nome }}</h6>
              <button
                class="br-button secondary small text-nowrap"
                type="button"
                (click)="baixarTermoPdf(termo)"
              >
                <i class="fas fa-file-pdf me-1"></i> Baixar em PDF
              </button>
            </div>

            @if (termo.stUploadAssinado) {
              <div class="alert alert-warning">
                <i class="fas fa-exclamation-triangle me-1"></i>
                Baixe o termo, imprima, colete as assinaturas dos responsáveis
                pelos estabelecimentos e anexe o documento digitalizado.
              </div>
            }

            <div
              [id]="'termo-conteudo-' + termo.id"
              class="termo-conteudo-box border rounded p-3"
            >
              <div [innerHTML]="termoConteudoSeguro(termo)"></div>
              @if (termo.stUploadAssinado) {
                <ng-container
                  *ngTemplateOutlet="resumoVagasTable"
                ></ng-container>
              }
            </div>
            @if (termo.stUploadAssinado) {
              <div class="mt-3">
                @if (nuRefDocumentoConfirmacao) {
                  <button
                    class="br-button secondary small mb-2"
                    type="button"
                    (click)="baixarDocumentoAnexado()"
                  >
                    <i class="fas fa-download me-1"></i> Baixar documento
                    anexado
                  </button>
                }
                @if (!acoesBloqueadas()) {
                  <app-upload
                    label="Anexar documento assinado *"
                    tipo="CONFIRMACAO_VAGA_APRIMORAMENTO"
                    [autoUpload]="false"
                    [multiple]="false"
                    [totalFilesAllowed]="1"
                    [allowedExtensions]="['pdf', 'jpg', 'jpeg', 'png']"
                    (uploadSuccess)="onUploadDocumento(termo.id, $event)"
                    (uploadError)="onUploadError($event)"
                    (deleteUpload)="onDeleteUpload(termo.id)"
                  ></app-upload>
                }
              </div>
            }
            @if (termo.modeloTermoConfirmacao?.ciencia) {
              <div class="mt-3">
                <div class="border rounded p-2 mb-2">
                  {{ termo.modeloTermoConfirmacao?.ciencia }}
                </div>
                <div class="d-flex align-items-center">
                  <input
                    type="checkbox"
                    class="form-check-input me-2"
                    [id]="'ciencia-' + termo.id"
                    [checked]="ciencias.get(termo.id)"
                    [disabled]="acoesBloqueadas()"
                    (change)="onCienciaChange(termo.id, $event)"
                  />
                  <label [for]="'ciencia-' + termo.id" class="mb-0">
                    Estou ciente do conteúdo acima.
                    <span class="text-danger">*</span>
                  </label>
                </div>
              </div>
            }
          </div>
        </div>
      }
      @if (termos.length === 0) {
        <div class="alert alert-info">
          Nenhum termo encontrado para este ciclo.
        </div>
      }
    </div>
    <div class="d-flex justify-content-end mt-4 gap-2">
      @if (acoesBloqueadas()) {
        <button
          class="br-button secondary"
          type="button"
          (click)="voltarParaConclusao()"
        >
          Voltar
        </button>
      } @else {
        <button class="br-button secondary" type="button" (click)="goToStep(2)">
          Voltar
        </button>
        <button
          class="br-button primary"
          type="button"
          [disabled]="submitting"
          (click)="confirmar()"
        >
          @if (submitting) {
            <i class="fas fa-spinner fa-spin me-1"></i>
          }
          Confirmar
        </button>
      }
    </div>
  }
</div>
